import { ChargingStation } from '@/types/task';
import StationCard from './StationCard';
import { StationCardSkeleton } from './ui/enhanced-loading';

interface StationListProps {
  stations: ChargingStation[];
  searchQuery: string;
  isLoading?: boolean;
}

const StationList = ({ stations, searchQuery, isLoading }: StationListProps) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 9 }).map((_, index) => (
          <StationCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  const filteredStations = stations.filter((station) => {
    if (!searchQuery) return true;
    
    const query = searchQuery.toLowerCase();
    return (
      station.title.toLowerCase().includes(query) ||
      station.location.toLowerCase().includes(query) ||
      (station.address && station.address.toLowerCase().includes(query)) ||
      station.chargerType.toLowerCase().includes(query) ||
      station.amenities?.some(amenity => amenity.toLowerCase().includes(query))
    );
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fade-in">
      {filteredStations.length > 0 ? (
        filteredStations.map((station, index) => (
          <div 
            key={station.id} 
            className="animate-fade-in"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <StationCard station={station} />
          </div>
        ))
      ) : (
        <div className="col-span-full text-center py-20 animate-fade-in">
          <div className="max-w-md mx-auto">
            <div className="text-6xl mb-4">🔍</div>
            <h3 className="text-2xl font-semibold mb-2">No charging stations found</h3>
            <p className="text-muted-foreground mb-6">
              We couldn't find any stations matching your criteria. Try adjusting your search or filters.
            </p>
            <div className="text-sm text-muted-foreground">
              <p>• Check your spelling</p>
              <p>• Try broader search terms</p>
              <p>• Clear filters to see all stations</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StationList;
